<template>
  <div class="error-container1">
    <section class="section-banner">
      <Slick
        v-if="BannersImage.length > 0"
        ref="OfferSlick"
        :options="landingBanner"
      >
        <div v-for="(banner, key) in BannersImage" :key="key">
          <div class="bannerContainer">
            <!-- <img src="@/assets/img/alita.jpg" class="" alt=""> -->
            <img :src="banner.promotion_card_img" class alt />
            <div class="filterbox">
              <div class="bannerContent">
                <div class="w-75 pr-2">
                  <div class="bannerTitle">{{ banner.title }}</div>
                  <div class="d-none details">
                    <span>{{ banner.lang }}</span>
                    <span>|</span>
                    <span>{{ banner.runtime }}</span>
                    <span>|</span>
                    <span>{{ banner.rated }}</span>
                  </div>
                </div>
                <!-- <div class="w-25">
                  <router-link :to="{ name: 'movie', params: { movieID: banner.id }}" class="jm-bookNow">BOOK NOW</router-link>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </Slick>
      <div
        v-else-if="BannersImage.length == 0 && !data_loading"
        class="text-center mx-auto h1"
      >
        No Offers Available
      </div>
    </section>
  </div>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import {
  PROJECT,
  METAWEBSITE,
  METAORGANIZATION,
  metaInfo
} from "@/helper/constant.js";
export default {
  name: "Offers",

  components: {
    Slick
  },
  metaInfo: metaInfo,
  data() {
    return {
      BannersImage: [],
      metaWebsite: METAWEBSITE,
      metaOrganization: METAORGANIZATION,
      project: PROJECT,
      landingBanner: {
        dots: true,
        arrows: true,
        autoplay: true,
        loop: true,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        autoplaySpeed: 3500,
        centerPadding: "10%",
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              centerMode: false
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getallShows();
  },
  methods: {
    getallShows: function() {
      this.showLoading();
      let payload = {};
      makeRequest("/GetAllShow", "POST", null, payload).then(response => {
        const { error, res } = response;
        this.hideLoading();
        this.BannersImage = res.data.Promotions;
        if (this.BannersImage.length > 0) {
          this.$nextTick(() => {
            this.$refs.OfferSlick.destroy();
            this.$refs.OfferSlick.create();
            this.$refs.OfferSlick.goTo(1, true);
          });
        }
      });
    }
  }
};
</script>

<style>
.error-container1 {
  height: calc(100vh - 400px);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/offers.vue